<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('科普文章')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a @click="copyLink(record)" v-clipboard:copy="linkUrl" v-clipboard:success="onCopy" v-clipboard:error="onError">复制链接</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <website-article-modal ref="modalForm" style="width: 1605px;" @ok="modalFormOk"></website-article-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import WebsiteArticleModal from './modules/WebsiteArticleModal'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  export default {
    name: 'WebsiteArticleList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      WebsiteArticleModal
    },
    data () {
      return {
        description: '科普文章管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'文章标题',
            align:"center",
            dataIndex: 'title'
          },
          {
            title:'文章类型',
            align:"center",
            dataIndex:'type',
            customRender: (text) => (text ? filterMultiDictText(this.dictOptions['type'], text) : ''),
          },
          // {
          //   title:'文章类型',
          //   align:"center",
          //   dataIndex: 'type_dictText'
          // },
          // {
          //   title:'文章类型',
          //   align:"center",
          //   dataIndex: 'typeName'
          // },
          {
            title:'上架',
            align:"center",
            dataIndex: 'isUp',
            customRender: (text) => (text ? filterMultiDictText(this.dictOptions['isUp'], text) : ''),
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/zyWebsite/websiteArticle/list",
          delete: "/zyWebsite/websiteArticle/delete",
          deleteBatch: "/zyWebsite/websiteArticle/deleteBatch",
          exportXlsUrl: "/zyWebsite/websiteArticle/exportXls",
          importExcelUrl: "zyWebsite/websiteArticle/importExcel",
          
        },
        dictOptions:{},
        linkUrl:''
      }
    },
    created() {
      this.$set(this.dictOptions, 'isUp', [{text:'是',value:'Y'},{text:'否',value:'N'}])
      this.$set(this.dictOptions, 'type', [{text:'仪器设备',value:'0'},{text:'治疗疗法',value:'1'},{text:'院内动态',value:'2'},{text:'义诊活动',value:'3'},{text:'大医中研',value:'4'}])
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
      copyLink(record){
        this.linkUrl = 'https://bjzyzyy.net/healthyDetails?id='+record.id
      },
      onCopy() {
        this.$message.success("复制成功!");
      },
      onError() { 
        this.$message.error("复制失败!");
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
<style>
.ant-modal{
  width:1600px !important;
}
</style>